import EmdEnumValueListView from "@/views/manager/EmdEnumValueListView.vue";
export default {
  name: "EnumValueListView",
  components: {
    EmdEnumValueListView
  },
  data() {
    return {
      type: this.$route.params.type,
      title: '-',
      createVisible: false,
      initQuery: {
        type: this.$route.params.type,
        extra: true
      },
      switches: {}
    };
  },
  methods: {
    onFetchData(data) {
      this.title = data.title + '枚举管理';
    }
  }
};